import { createSlice } from '@reduxjs/toolkit'
import { Translate } from 'react-redux-i18n'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../../helpers/EventEmitter'
import { getUnique, keyBy } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import {
  changeValueWithDot,
  isInValidValue,
} from '../../../../../helpers/value'

const initialState = {
  panelById: {},
  panelId: [],
  templateName: '',
  defaultTemplate: { panelById: {}, panelId: [] },
  activePanel: null,
  isShowDetail: true,
  isFiinGateTemplate: false,
  companyType: '',
  isDisableBlockNavigate: false,
}

const slice = createSlice({
  name: 'companyAnalysis/preferenceSetting/detailTemplate',
  initialState,
  reducers: {
    resetFullStoreDetailTemplate() {
      return initialState
    },
    resetStoreDetailTemplate(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
    addPanel: (state, action) => {
      const panel = {
        ...action.payload,
        id: getUnique(),
      }
      state.panelById[panel.id] = panel
      state.panelId.push(panel.id)
    },
    changeName: (state, action) => {
      state.templateName = action.payload
    },
    addDefault: (state, action) => {
      const {
        panelsSelected,
        templateName,
        templateId,
        isFiinGateTemplate,
        companyType,
      } = action.payload
      const panelId = panelsSelected.map((panel) => panel.id)
      const panelById = keyBy(panelsSelected, 'id')

      state.defaultTemplate = {
        ...state.defaultTemplate,
        templateId,
        templateName,
      }

      state.templateName = templateName
      state.panelId = panelId
      state.panelById = panelById
      state.isFiinGateTemplate = isInValidValue(isFiinGateTemplate)
        ? state.isFiinGateTemplate
        : isFiinGateTemplate
      state.companyType = companyType || ''
    },
    changeId: (state, action) => {
      state.panelId = action.payload
    },
    removePanel: (state, action) => {
      if (state.panelId.length > 1) {
        const removeId = action.payload
        state.panelId = state.panelId.filter((id) => id !== removeId)
        delete state.panelById[removeId]
      } else {
        EventEmitter.dispatch(SHOW_POPUP_ERROR, {
          messages: [
            <Translate value="preferenceSetting.WARNING_DELETE_PANEL" />,
          ],
        })
      }
    },
    resetDefault: (state) => {
      state.panelById = state.defaultTemplate.panelById
      state.panelId = state.defaultTemplate.panelId
      state.templateName = state.defaultTemplate.templateName
      state.activePanel = null
    },
    changeActivePanel: (state, action) => {
      state.activePanel = action.payload
    },
    changeValue: (state, action) => {
      const { id, key, value } = action.payload
      state.panelById[id] = changeValueWithDot(state.panelById[id], key, value)
    },
    changeIsDisableBlockNavigate: (state) => {
      state.isDisableBlockNavigate = !state.isDisableBlockNavigate
    },
    addDefaultTemplate: (state, action) => {
      const { panelById, panelId } = action.payload
      state.defaultTemplate.panelId = panelId
      state.defaultTemplate.panelById = panelById
    },
  },
})

export const {
  addPanel,
  changeName,
  resetStoreDetailTemplate,
  addDefault,
  changeId,
  removePanel,
  resetDefault,
  changeActivePanel,
  changeValue,
  resetFullStoreDetailTemplate,
  changeIsDisableBlockNavigate,
  addDefaultTemplate,
} = slice.actions

export const selectPanelId = (state) => state[slice.name].panelId

export const selectPanelById = (state) => state[slice.name].panelById

export const selectDetailPanel = (id) => (state) =>
  state[slice.name].panelById[id]

export const selectName = (state) => state[slice.name].templateName

export const selectActivePanel = (state) => state[slice.name].activePanel

export const selectDefaultTemplate = (state) =>
  state[slice.name].defaultTemplate

export const selectIsFiinGateTemplate = (state) =>
  state[slice.name].isFiinGateTemplate

export const selectCompanyTypeTemplate = (state) =>
  state[slice.name].companyType

export const selectIsDisableBlockNavigate = (state) =>
  state[slice.name].isDisableBlockNavigate

export const selectState = (state) => state[slice.name]

register(slice.name, slice.reducer)
